import { Comments } from '@hyvor/hyvor-talk-react';

export const CommentsModule = ({ page_id }: { page_id: string }) => {
  return (
    <div className="container sm:w-[calc(100%-2rem)] md:w-[calc(100%-1rem)] md:max-w-[726px] lg:relative">
      <Comments page-id={page_id} website-id={13265} />
    </div>
  );
};
